import { proPageService } from '../network/services/pro-page.service';
import { ResponseError } from '../network/response/response-error';

export default {
  namespaced: true,
  state: {
    loading: false,
    pros: [],
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = !!payload;
    },
    SET_PROS(state, payload) {
      state.pros = payload;
    }
  },
  actions: {
    async fetch(context) {
      context.commit('SET_LOADING', true);
      const lang = context.rootState.lang.currentLang;
      const response = await proPageService.fetch({ lang });
      const pros = response.get('Pros.many', []);
      if (pros instanceof ResponseError) {
        // TODO catch errors
      } else {
        context.commit('SET_PROS', pros);
      }
      context.commit('SET_LOADING', false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/pro-page.store.js